// ─── generators/zendingDetail.js ──────────────────────────────────────────────────
// Rapportgenerator: genZendingDetail.
// Wijzig hier bij aanpassingen aan dit specifieke rapporttype.

import { MAANDEN, MAANDEN_K, fmtE, fmtD, fmtKg, fmtK, diff, statusLabel, statusBadge, isOnderweg } from '../helpers.js';
import { header, kpiBlok, pageCss, sectTitel, sectTitelKlein, footer, wrapMetHerhalendeHeader } from '../layout.js';
import { balkGrafiek, balkGrafiek3D, lijnGrafiek, taartGrafiek, dubbeleGrafiek, hBalk, renderRanking, renderGrafiek } from '../charts.js';
import { verwerkData } from '../data.js';

function genZendingDetail(aanvragen, bedrijfsnaam, cfg, logo) {
  const a = cfg.gekozen;
  if(!a) return '<p style="padding:20px;color:#94a3b8;">Selecteer een zending</p>';
  // Prijs uit KlantPrijzen JSON ({"Vervoerder":"bedrag"}) of directe velden
  let bedrag = 0;
  if(a.KlantPrijzen && a.GekozenVervoerder) {
    try {
      const kp = typeof a.KlantPrijzen==='string' ? JSON.parse(a.KlantPrijzen) : a.KlantPrijzen;
      bedrag = parseFloat(kp[a.GekozenVervoerder]) || 0;
    } catch(e) {}
  }
  if(!bedrag) bedrag = parseFloat(a.KlantPrijs) || parseFloat(a.Factuur) || 0;
  const goederen = [1,2,3,4,5].map(n=>({
    omschr:a[`Goed${n}_Omschrijving`]||'', soort:a[`Goed${n}_Soort`]||'',
    aantal:a[`Goed${n}_Aantal`]||'', gew:a[`Goed${n}_Gewicht`]||'',
    l:a[`Goed${n}_Lengte`]||'', b:a[`Goed${n}_Breedte`]||'', h:a[`Goed${n}_Hoogte`]||'',
  })).filter(g=>g.omschr||g.soort||g.aantal);

  const _css = '<style>' + pageCss(cfg.orientatie) + '</style>';
  const _hdr = header(`Zending ${a.AanvraagID}`, `${a.LaadPlaats||a.LaadLand||'—'} → ${a.LosPlaats||a.LosLand||'—'}`, bedrijfsnaam, logo);
  let body = '';

  // Status banner
  body += `<div style="background:${statusLabel(a)==='Afgeleverd'?'#d1fae5':statusLabel(a)==='Onderweg'?'#dbeafe':'#f7f6f2'};border-radius:8px;padding:10px 16px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:center;">
    <span style="font-size:12px;font-weight:600;color:#1a364c;">Status</span>
    ${statusBadge(statusLabel(a))}
  </div>`;

  // Adressen
  body += `<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:16px;">
    <div style="border:1px solid #e8edf3;border-radius:8px;padding:12px;">
      <div style="font-size:9px;font-weight:700;color:#1a364c;text-transform:uppercase;letter-spacing:.07em;margin-bottom:8px;border-bottom:1px solid #e8edf3;padding-bottom:5px;">📍 Laadgegevens</div>
      ${[['Datum',fmtD(a.Datum)],['Laadplaats',a.LaadPlaats||'—'],['Land',a.LaadLand||'—'],['Datum laden',fmtD(a.LaadDatum)],['Adres',a.LaadAdres||'—']].map(([l,v])=>`
        <div style="display:flex;gap:8px;margin-bottom:5px;">
          <span style="font-size:10px;color:#64748b;width:80px;flex-shrink:0;">${l}</span>
          <span style="font-size:10px;font-weight:500;color:#1e293b;">${v}</span>
        </div>`).join('')}
    </div>
    <div style="border:1px solid #e8edf3;border-radius:8px;padding:12px;">
      <div style="font-size:9px;font-weight:700;color:#1a364c;text-transform:uppercase;letter-spacing:.07em;margin-bottom:8px;border-bottom:1px solid #e8edf3;padding-bottom:5px;">🏁 Losgegevens</div>
      ${[['Losplaats',a.LosPlaats||'—'],['Land',a.LosLand||'—'],['Datum lossen',fmtD(a.LosDatum)],['Adres',a.LosAdres||'—'],['Referentie',a.Referentie1||'—']].map(([l,v])=>`
        <div style="display:flex;gap:8px;margin-bottom:5px;">
          <span style="font-size:10px;color:#64748b;width:80px;flex-shrink:0;">${l}</span>
          <span style="font-size:10px;font-weight:500;color:#1e293b;">${v}</span>
        </div>`).join('')}
    </div>
  </div>`;

  // Goederen
  if(goederen.length>0) {
    body += sectTitel('Goederen');
    body += `<table style="width:100%;border-collapse:collapse;font-size:10px;">
      <thead><tr style="background:#f7f6f2;">
        ${['#','Omschrijving','Soort','Aantal','Gewicht','L×B×H (cm)'].map(h=>`<th style="padding:6px 8px;text-align:left;font-size:9px;font-weight:700;color:#1a364c;text-transform:uppercase;letter-spacing:.05em;border-bottom:1px solid #e8edf3;">${h}</th>`).join('')}
      </tr></thead>
      <tbody>${goederen.map((g,i)=>`
        <tr style="border-bottom:1px solid #f5f5f5;">
          <td style="padding:6px 8px;color:#94a3b8;">${i+1}</td>
          <td style="padding:6px 8px;font-weight:500;">${g.omschr||'—'}</td>
          <td style="padding:6px 8px;">${g.soort||'—'}</td>
          <td style="padding:6px 8px;">${g.aantal||'—'}</td>
          <td style="padding:6px 8px;">${g.gew?`${g.gew} kg`:'—'}</td>
          <td style="padding:6px 8px;">${g.l&&g.b&&g.h?`${g.l}×${g.b}×${g.h}`:'—'}</td>
        </tr>`).join('')}
      </tbody>
    </table>`;
  }

  // Kosten
  if(bedrag>0) {
    body += `<div style="margin-top:14px;background:#f7f6f2;border-radius:8px;padding:12px 16px;display:flex;justify-content:space-between;align-items:center;">
      <span style="font-size:12px;font-weight:600;color:#1a364c;">Transportkosten</span>
      <span style="font-size:18px;font-weight:800;color:#1a364c;">${fmtE(bedrag)}</span>
    </div>`;
  }
  if(a.FactuurNr) {
    body += `<div style="margin-top:8px;font-size:10px;color:#64748b;">Factuurnummer: <strong>${a.FactuurNr}</strong></div>`;
  }

  body += footer();
  return wrapMetHerhalendeHeader(_css, _hdr, body);
}

export { genZendingDetail };
